import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SupervisionService {
    /**
     * Update Supervision
     * Handle a user's update for the supervision state of a given action.
     *
     * This will, after validating that the user has permissions for this
     * deployment, send down a message over the deployment supervision websocket.
     * @param deploymentId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateSupervision(deploymentId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/deploy/supervise/{deployment_id}/action',
            path: {
                'deployment_id': deploymentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
